// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"134cf029","13":"7ae6b5c8","226":"a21793f3","447":"8da7c9d6","601":"2c254fbd","677":"21e51160","787":"98c4534b","941":"458624d0"}[chunkId] + ".chunk.js";
};